<template>
  <el-dialog
    title="退款明细"
    :visible.sync="dialogVisible"
    width="60vw"
    top="5vh"
    append-to-body
    @close="handleClose"
  >
    <div class="refund-detail-wrap">
      <!-- 共用筛选 -->
      <div class="refund-toolbar">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          start-placeholder="开始时间"
          range-separator="-"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          style="width: 360px"
          @change="handleQuery"
        />
        <el-button icon="el-icon-search" type="primary" @click="handleQuery">查询</el-button>
      </div>

      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <!-- ===================== 退款明细（订单支付退款） ===================== -->
        <el-tab-pane label="退款明细" name="pay">
          <el-table
            v-loading="payLoading"
            :data="payList"
            border
            stripe
            style="width: 100%"
            height="480"
          >
            <el-table-column type="expand" width="40">
              <template #default="{ row }">
                <div class="expand-box">
                  <div class="expand-section">
                    <div class="expand-title">退款金额明细</div>
                    <el-row :gutter="12">
                      <el-col :span="6">
                        <div class="kv"><span>商品退款</span><b class="red">¥{{ row.refund_goods_price }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>运费退款</span><b class="red">¥{{ row.refund_postage }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>税金退款</span><b class="red">¥{{ row.refund_tax }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>优惠券抵扣</span><b class="red">¥{{ row.coupon_money }}</b></div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="12" style="margin-top: 8px">
                      <el-col :span="6">
                        <div class="kv"><span>积分抵扣</span><b>{{ row.point || '0.00' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>余额退款</span><b>{{ row.balance || '0.00' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>退款总额</span><b class="red">¥{{ row.price }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>订单商品规格ID</span><b>{{ row.order_goods_spec_id || '-' }}</b></div>
                      </el-col>
                    </el-row>
                  </div>

                  <div class="expand-section">
                    <div class="expand-title">支付通道信息</div>
                    <el-row :gutter="12">
                      <el-col :span="6">
                        <div class="kv"><span>退款单号</span><b>{{ row.refno || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>交易号</span><b>{{ row.transid || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>原交易金额</span><b>{{ row.reqamt ? '¥' + row.reqamt : '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>本次退款</span><b>{{ row.voidamt ? '¥' + row.voidamt : '-' }}</b></div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="12" style="margin-top: 8px">
                      <el-col :span="6">
                        <div class="kv"><span>响应码</span><b>{{ row.rescode || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>响应信息</span><b>{{ row.resmsg || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>退款成功时间</span><b>{{ row.resdt || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>退款原因码</span><b>{{ row.reasoncode || '-' }}</b></div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="add_time" label="退款时间" width="160" />
            <el-table-column prop="price" label="退款金额" width="100" align="right">
              <template #default="{ row }">
                <span class="red">¥{{ row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="退款类型" width="100" align="center">
              <template #default="{ row }">
                <el-tag size="mini" type="success">{{ typeMap[row.type] || row.type }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="reasondesc" label="退款原因" width="110" show-overflow-tooltip>
              <template #default="{ row }">{{ row.reasondesc || '-' }}</template>
            </el-table-column>
            <el-table-column prop="refund_remarks" label="备注" min-width="120" show-overflow-tooltip>
              <template #default="{ row }">{{ row.refund_remarks || '-' }}</template>
            </el-table-column>
            <el-table-column prop="refno" label="退款单号" min-width="200" show-overflow-tooltip />
            <el-table-column prop="transid" label="交易号" min-width="160" show-overflow-tooltip />
          </el-table>

          <el-pagination
            background
            :current-page="payQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="payQuery.limit"
            :total="payTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handlePayCurrentChange"
            @size-change="handlePaySizeChange"
          />
        </el-tab-pane>

        <!-- ===================== 申请退款记录 ===================== -->
        <el-tab-pane label="申请退款记录" name="apply">
          <el-table
            v-loading="applyLoading"
            :data="applyList"
            border
            stripe
            style="width: 100%"
            height="480"
          >
            <el-table-column type="expand" width="40">
              <template #default="{ row }">
                <div class="expand-box">
                  <!-- 商品信息 -->
                  <div class="expand-section">
                    <div class="expand-title">退款商品信息</div>
                    <el-row :gutter="12">
                      <el-col :span="8">
                        <div class="kv"><span>商品名称</span><b>{{ row.goods_name || '-' }}</b></div>
                      </el-col>
                      <el-col :span="8">
                        <div class="kv"><span>规格</span><b>{{ row.goods_sku || '-' }}</b></div>
                      </el-col>
                      <el-col :span="8">
                        <div class="kv"><span>商品单价</span><b class="red">¥{{ row.goods_price }}</b></div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="12" style="margin-top: 8px">
                      <el-col :span="8">
                        <div class="kv"><span>购买数量</span><b>{{ row.goods_num }}</b></div>
                      </el-col>
                      <el-col :span="8">
                        <div class="kv"><span>退款数量</span><b>{{ row.goods_refund_num }}</b></div>
                      </el-col>
                      <el-col :span="8">
                        <div class="kv"><span>订单商品规格ID</span><b>{{ row.order_goods_spec_id || '-' }}</b></div>
                      </el-col>
                    </el-row>
                    <el-row v-if="row.goods_pic" :gutter="12" style="margin-top: 8px">
                      <el-col :span="24">
                        <div class="kv">
                          <span>商品图片</span>
                          <b>
                            <el-image
                              :src="row.goods_pic"
                              :preview-src-list="[row.goods_pic]"
                              style="width: 56px; height: 56px; border-radius: 4px"
                              fit="cover"
                            />
                          </b>
                        </div>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- 金额 & 订单信息 -->
                  <div class="expand-section">
                    <div class="expand-title">金额与订单信息</div>
                    <el-row :gutter="12">
                      <el-col :span="6">
                        <div class="kv"><span>申请金额</span><b class="red">¥{{ row.apply_amount }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>运费退款</span><b class="red">¥{{ row.refund_postage }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>税金退款</span><b class="red">¥{{ row.refund_tax }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>优惠券抵扣</span><b class="red">¥{{ row.coupon_money }}</b></div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="12" style="margin-top: 8px">
                      <el-col :span="6">
                        <div class="kv"><span>订单退款总额</span><b class="red">¥{{ row.refund_price }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>订单号</span><b>{{ row.order_code || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>退款单ID</span><b>{{ row.id || '-' }}</b></div>
                      </el-col>
                      <el-col :span="6">
                        <div class="kv"><span>退款类型</span><b>{{ typeMap[row.type] || row.type || '-' }}</b></div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="add_time" label="申请时间" width="160">
              <template #default="{ row }">{{ row.add_time || '-' }}</template>
            </el-table-column>
            <el-table-column label="商品" min-width="220" show-overflow-tooltip>
              <template #default="{ row }">
                <div class="goods-cell">
                  <el-image
                    v-if="row.goods_pic"
                    :src="row.goods_pic"
                    style="width: 36px; height: 36px; border-radius: 4px; flex-shrink: 0"
                    fit="cover"
                  />
                  <div class="goods-cell__info">
                    <div class="goods-cell__name">{{ row.goods_name || '-' }}</div>
                    <div class="goods-cell__sku">{{ row.goods_sku || '-' }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="退款数量" width="90" align="center">
              <template #default="{ row }">{{ row.goods_refund_num }}</template>
            </el-table-column>
            <el-table-column label="申请金额" width="110" align="right">
              <template #default="{ row }">
                <span class="red">¥{{ row.apply_amount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="apply_reason" label="申请原因" min-width="140" show-overflow-tooltip>
              <template #default="{ row }">{{ row.apply_reason || '-' }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="110" align="center">
              <template #default="{ row }">
                <el-tag
                  size="mini"
                  :type="applyStatusMap[row.status] ? applyStatusMap[row.status].type : 'info'"
                >
                  {{ applyStatusMap[row.status] ? applyStatusMap[row.status].label : (row.status_text || row.status || '-') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="审核时间" width="160">
              <template #default="{ row }">{{ row.update_time || row.audit_time || row.check_time || '-' }}</template>
            </el-table-column>
            <el-table-column label="审核备注" min-width="160" show-overflow-tooltip>
              <template #default="{ row }">{{ row.audit_remark || row.remark || row.refuse_reason || '-' }}</template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            :current-page="applyQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="applyQuery.limit"
            :total="applyTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handleApplyCurrentChange"
            @size-change="handleApplySizeChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>

    <div slot="footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { order_pay_refund_list, order_apply_refund_list } from '@/api/xgcApi'

function parseJSON(str) {
  if (!str) return {}
  if (typeof str === 'object') return str
  try {
    return JSON.parse(str)
  } catch (e) {
    return {}
  }
}

export default {
  name: 'RefundDetail',
  data() {
    return {
      dialogVisible: false,
      time: [],
      activeTab: 'pay',

      // ===== 退款明细 =====
      payLoading: false,
      payList: [],
      payTotal: 0,
      payQuery: {
        order_id: '',
        page: 1,
        limit: 10,
        start_time: '',
        end_time: '',
      },
      typeMap: {
        1: '积分退款',
        2: '余额退款',
        3: '原路退回',
      },

      // ===== 申请退款记录 =====
      applyLoading: false,
      applyList: [],
      applyTotal: 0,
      applyQuery: {
        order_id: '',
        page: 1,
        limit: 10,
        start_time: '',
        end_time: '',
      },
      // 申请退款状态（按后端实际状态值调整）
      applyStatusMap: {
        0: { label: '待审核', type: 'warning' },
        1: { label: '审核通过', type: 'success' },
        2: { label: '已拒绝', type: 'danger' },
        3: { label: '已退款', type: 'success' },
      },
    }
  },
  methods: {
    open(row) {
      const orderId = row.id
      this.time = []
      this.activeTab = 'pay'

      this.payQuery = { order_id: orderId, page: 1, limit: 10, start_time: '', end_time: '' }
      this.applyQuery = { order_id: orderId, page: 1, limit: 10, start_time: '', end_time: '' }
      this.payList = []
      this.applyList = []
      this.payTotal = 0
      this.applyTotal = 0

      this.dialogVisible = true
      this.fetchPayList()
    },

    handleTabChange(tab) {
      if (tab.name === 'apply' && this.applyList.length === 0 && !this.applyLoading) {
        this.fetchApplyList()
      }
    },

    handleQuery() {
      const s = this.time && this.time.length === 2 ? this.time[0] : ''
      const e = this.time && this.time.length === 2 ? this.time[1] : ''

      this.payQuery.start_time = s
      this.payQuery.end_time = e
      this.payQuery.page = 1

      this.applyQuery.start_time = s
      this.applyQuery.end_time = e
      this.applyQuery.page = 1

      if (this.activeTab === 'pay') {
        this.fetchPayList()
      } else {
        this.fetchApplyList()
      }
    },

    // ===== 退款明细：数据 + 分页 =====
    async fetchPayList() {
      if (!this.payQuery.order_id) return
      this.payLoading = true
      try {
        const { data } = await order_pay_refund_list(this.payQuery)
        const rawList = (data && data.list) || []
        this.payList = rawList.map((item) => {
          const dataObj = parseJSON(item.data)
          const refundDetail = dataObj.refund_detail || {}
          const icbData = dataObj.icb_data || {}
          const refundData = parseJSON(item.refund_data)
          return {
            ...item,
            refund_goods_price: refundDetail.refund_goods_price || '0.00',
            refund_postage: refundDetail.refund_postage || '0.00',
            refund_tax: refundDetail.refund_tax || '0.00',
            coupon_money: refundDetail.coupon_money || item.coupon_money || '0.00',
            refno: icbData.refno || refundData.refno || '',
            transid: icbData.transid || refundData.transid || '',
            reqamt: icbData.reqamt || '',
            voidamt: icbData.voidamt || '',
            reasoncode: icbData.reasoncode || '',
            reasondesc: icbData.reasondesc || refundData.reasondesc || '',
            rescode: refundData.rescode || '',
            resmsg: refundData.resmsg || '',
            resdt: refundData.resdt || '',
          }
        })
        this.payTotal = Number(data && data.count) || 0
      } catch (e) {
        this.payList = []
        this.payTotal = 0
      } finally {
        this.payLoading = false
      }
    },
    handlePaySizeChange(val) {
      this.payQuery.limit = val
      this.fetchPayList()
    },
    handlePayCurrentChange(val) {
      this.payQuery.page = val
      this.fetchPayList()
    },

    // ===== 申请退款记录：数据 + 分页 =====
    async fetchApplyList() {
      if (!this.applyQuery.order_id) return
      this.applyLoading = true
      try {
        const { data } = await order_apply_refund_list(this.applyQuery)
        const rawList = (data && data.list) || []
        // 将 order_sku_refund 扁平化，避免模板中深层取值兼容性问题
        this.applyList = rawList.map((item) => {
          const sku = item.order_sku_refund || {}
          return {
            ...item,
            apply_amount: item.apply_amount || '0.00',
            refund_price: item.refund_price || '0.00',
            refund_postage: item.refund_postage || '0.00',
            refund_tax: item.refund_tax || '0.00',
            coupon_money: item.coupon_money || '0.00',
            goods_name: sku.goods_name || '',
            goods_sku: sku.sku || '',
            goods_num: sku.num || 0,
            goods_refund_num: sku.refund_num || 0,
            goods_price: sku.price || '0.00',
            goods_pic: sku.pic || '',
          }
        })
        this.applyTotal = Number(data && data.count) || 0
      } catch (e) {
        this.applyList = []
        this.applyTotal = 0
      } finally {
        this.applyLoading = false
      }
    },
    handleApplySizeChange(val) {
      this.applyQuery.limit = val
      this.fetchApplyList()
    },
    handleApplyCurrentChange(val) {
      this.applyQuery.page = val
      this.fetchApplyList()
    },

    handleClose() {
      this.dialogVisible = false
      this.payList = []
      this.applyList = []
      this.payTotal = 0
      this.applyTotal = 0
    },
  },
}
</script>

<style scoped>
.refund-detail-wrap {
  padding: 0 4px;
}
.refund-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
::v-deep .el-pagination {
  margin-top: 16px;
  text-align: right;
}
.red {
  color: #e35b5b;
}
.expand-box {
  padding: 10px 16px;
  background: #fafbfd;
  border-radius: 4px;
}
.expand-section + .expand-section {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e4e8ef;
}
.expand-title {
  margin-bottom: 8px;
  color: #303b4f;
  font-weight: 600;
}
.kv {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
  line-height: 20px;
}
.kv span {
  color: #8993a5;
  white-space: nowrap;
}
.kv b {
  color: #455166;
  font-weight: 500;
  text-align: right;
  overflow-wrap: anywhere;
}
.kv b.red {
  color: #e35b5b;
}
.goods-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.goods-cell__info {
  min-width: 0;
}
.goods-cell__name {
  color: #303b4f;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.goods-cell__sku {
  color: #8993a5;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>